import {  useQuery } from "@tanstack/react-query";
import { customFetcher } from "../useFetch";
import { IUnit } from "../../interfaces/IUnit";

export const useGetUnits = () => {
    const {
        data: units,
        isLoading: isLoadingUnits,
        refetch: refetchUnits,
    } = useQuery<IUnit[]>({
        queryKey: ["unit/"],
        queryFn: () => customFetcher({ endpoint: "/unit/" }),
    });
    return { units, isLoadingUnits, refetchUnits };
};
